import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { AuthServiceService } from '@edtech-ui/core/services/authService/auth-service.service';
import { UserDetailResponse } from '@edtech-ui/core/models/Classroom/user-detail';
import { finalize, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@Component({
	selector: 'app-admin-header',
	standalone: true,
	imports: [MatIconModule, MatBadgeModule, MatButtonModule, CommonModule, MatTooltipModule, MatProgressSpinnerModule],
	templateUrl: './admin-header.component.html',
	styleUrl: './admin-header.component.scss'
})
export class AdminHeaderComponent implements OnInit, OnDestroy {

	@Input() pageTitle: string = '';
	@Input() pageSubTitle: string = '';
	@Input() adminName: String = '';
	userDetail: UserDetailResponse['Data'] | null = null;
	subscription = new Subscription();
	userId = '';
	isLoading = false;

	constructor(
		private _authService: AuthServiceService,
		private _toastr: ToastrService,
	) { }

	ngOnInit(): void {
		const storedId = localStorage.getItem('user_id');
		if (storedId) {
			this.userId = storedId;
			this.getUserDetails(this.userId);
		}
	}

	getUserDetails(id: string) {
		this.isLoading = true;
		this.subscription.add(
			this._authService.getUserDetails(id).pipe(
				finalize(() => {
					this.isLoading = false
				})
			).subscribe({
				next: (response: UserDetailResponse) => {
					if (response.Success) {
						this.userDetail = response.Data;
						this._authService.userStore$.next(response.Data);
					}
				},
				error: () => this._toastr.error('Something went wrong while fecthing the user Details')
			})
		);
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

}